import Cookies from 'universal-cookie';
import { backendBaseURL, errorMessages, routeURL } from './properties';
import axios from 'axios';
import { accessTokenGenerate } from 'src/services/auth.service';
import { socket } from 'src/App';
import { enqueueSnackbar } from 'notistack';
import { clearUserData } from './functions.utils';

export const Method = {
  POST: 'post',
  GET: 'get',
  PUT: 'put',
  DELETE: 'delete'
};

function addParamsToURL(url: string, params: any) {
  if (params) {
    let temp = url;
    temp = temp + '/' + params;
    return temp;
  }
  return url;
}

const getHeaders = async (token: string, adHeaders: object) => {
  const cookies = new Cookies();

  let validToken;
  if (cookies.get('access_token')) {
    validToken = await cookies.get('access_token');
  } else {
    try {
      await accessTokenGenerate();
      validToken = cookies.get('access_token');
    } catch (error) {
      localStorage.clear();
      window.location.href = routeURL.STUDENT_LOGIN;
    }
  }

  if (token !== null) {
    return {
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Authorization: `Bearer ${validToken}`,
        'Access-Control-Allow-Origin': '*',
        ...adHeaders
      }
    };
  } else {
    return {
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        'Access-Control-Allow-Origin': '*',
        ...adHeaders
      }
    };
  }
};

export default async function api(
  method: string,
  header: object | null,
  endPoint: string,
  token?: any,
  body?: any | null,
  params?: any
) {
  let customURL = addParamsToURL(backendBaseURL + endPoint, params);
  let headers = await getHeaders(token, header === null ? {} : header);
  socket.emit('room', 'student');

  return new Promise((resolve, reject) => {
    axios({
      method: method,
      url: customURL,
      data: body === '' ? undefined : body,
      headers: headers.headers
    })
      .then(function (response: any) {
        resolve(response);
      })
      .catch(function (error: any) {
        if (error?.response?.status === 401) {
          enqueueSnackbar(errorMessages.SESSION_EXPIRED, {
            variant: 'info'
          });
          clearUserData();
          window.location.href = routeURL.STUDENT_LOGIN;
        } else {
          reject(error.response);
        }
      });
  });
}
